import React from 'react';
import PlainCRUD from 'components/PlainCRUD';
import { getFuentes } from 'api/configuracion';

const Fuentes = () => (
  <PlainCRUD title="Fuentes" get={getFuentes} readOnly />
);

export default Fuentes;
